import { Component, OnInit } from '@angular/core';
import { EmployeeService } from '../../../../../shared/_services/employee.service';
import { FormBuilder, FormGroup, FormArray, FormControl } from '@angular/forms';
import { UtilService } from '../../../../../shared/_services/util.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { StatusModalComponent } from '../../../../modals/status-modal/status-modal.component';
import { Subject } from 'rxjs';
import { ImportComponent } from '../../../../modals/import/import.component';

@Component({
  selector: 'app-employee-list',
  templateUrl: './employee-list.component.html',
  styleUrls: ['./employee-list.component.scss']
})
export class EmployeeListComponent implements OnInit {
  statusModal: BsModalRef;
  activateAction: boolean;
  isFiltered: any;
  employeesList: any[] = [];
  searchForm: FormGroup;
  isFilterOn: boolean = false;
  filterForm: FormGroup;
  filterLookUpData: any;
  p: number = 0;
  size: number = 10;
  totalCount: any;
  promoList: any[] = [];
  allEmployeesSelected: boolean;
  selectedEmployees: any[] = [];
  tableHeader: any = [
    { 'key': 'Code', 'property': 'empCode', 'direction': 'asc' },
    { 'key': 'Email', 'property': 'email', 'direction': null },
    { 'key': 'First name', 'property': 'firstName', 'direction': null },
    { 'key': 'Last Name', 'property': 'lastName', 'direction': null },
    { 'key': 'Hotel', 'property': 'hotel', 'direction': null },
    { 'key': 'Status', 'property': 'status', 'direction': null },
  ];
  bsModalRef: BsModalRef;
  private unsubscribe: Subject<void> = new Subject<void>();
  constructor(
    private fb: FormBuilder,
    private modalService: BsModalService,
    private utilService: UtilService,
    private employeeService: EmployeeService
  ) {
    document.addEventListener('click', this.offClickHandler.bind(this));
    this.modalService.onHide
      .takeUntil(this.unsubscribe)
      .subscribe(res => {
        if (this.statusModal) {
          if (this.statusModal.content.srcObject.action == "action1") {
            if (this.statusModal.content.srcObject.type == "member-edit") {
              if (this.statusModal.content.srcObject.status || this.statusModal.content.srcObject.status == 0) {
                let status = +this.statusModal.content.srcObject.status;
                this.activateOrDeactivateEmployee(this.statusModal.content.srcObject.id, status);
              } else {
                // this.router.navigate(['/members']);
              }
            }
          }
        } else {
          this.pageChanged(1);
        }
      })
  }

  offClickHandler(event: any) {
    if (!event.target.closest(".filter") && !event.target.closest(".filter")) {
      // do whatever you want here
      if (document.getElementById('ul')) {
        document.getElementById('ul').style.display = 'none';
      }
    }
  }

  activateOrDeactivateEmployee(employeeIds, status) {
    console.log(` employee ${JSON.stringify(employeeIds)} was selected to ${status == 0 ? 'Deactivate' : 'Activate'}`)
    this.employeeService.activateOrDeactivateEmployee(employeeIds, status).subscribe(res => {
      if (res.error == 0) {
        this.pageChanged(this.p > 1 ? this.p : 1);
      }
    }, err => {
      console.error('Error Activating/Deactivating Employee: ', err.message);
    })
  }

  importEmployeesModal() {
    this.bsModalRef = this.modalService.show(ImportComponent, { class: 'modal-import' });
  }

  getfilterLookUpData() {
    this.employeeService.getLookupDataForEmployee().subscribe(res => {
      if (res.error == 0) {
        this.filterLookUpData = res.responseObj;
        this.checkSelected(true, 'hotelIds', 'hotels', 'hotelId', 0);
      }
    }, err => {
      console.error('Error while getting filter look up date: ', err.message);
    })
  }
  dropDown(e) {
    // event.stopPropagation();
    if (document.getElementById('ul').style.display == 'block') {
      document.getElementById('ul').style.display = 'none';
    } else {
      document.getElementById('ul').style.display = 'block';
    }
  }

  sortTable(property: any) {
    this.tableHeader.forEach((header: any) => {
      if (header.property === property) {
        header.direction = header.direction && header.direction == 'asc' ? 'desc' : 'asc';
        // header.direction = !header.direction;
      }
      if (header.property !== property) {
        header.direction = null;
      }
    });
    console.log('==========sorting array =========', this.tableHeader);
    this.pageChanged(1);
  }

  checkList(type, valueType) {
    return this.utilService.cleanArray(this.filterLookUpData[type].map(value => {
      if (value.checked) {
        // this.activateAction = true;
        console.log('checked');
        return value[valueType];
      } else {
        console.log('unchecked');
        return null;
      }
    }))
  }

  checkSelection(isAll, type, allType, selectedType, valueType) {
    if (isAll) {
      for (var i = 0; i < this.filterLookUpData[type].length; i++) {
        this.filterLookUpData[type][i].checked = this[allType];
      }
    } else {
      this[allType] = this.filterLookUpData[type].every(function (item: any) {
        return item.checked == true;
      })
    }
    let SelectedValues = this.checkList(type, valueType);
    // console.log(`================== slected values for ${type}  has all the selected value type of ${valueType}`, SelectedValues);
  }

  getSelectedStr(length, type) {
    return `${length} ${type}${length !== 1 ? 's' : ''} Selected`;
  }

  checkSelected(isChecked: boolean, controlName, type, valueType, value) {
    let formArray = this.filterForm.controls[controlName] as FormArray;
    if (isChecked) {
      if (value == 0) {
        while (formArray.value.length !== 0) {
          formArray.removeAt(0)
        }
        formArray.push(new FormControl(0));
        this.filterLookUpData[type].forEach(value => {
          formArray.push(new FormControl(value[valueType]));
        });
      } else {
        formArray.push(new FormControl(value));
        if (formArray.value.indexOf(0) == -1 && this.filterLookUpData[type].length == formArray.value.length) {
          formArray.push(new FormControl(0));
        }
      }
    } else {
      if (value == 0) {
        while (formArray.value.length !== 0) {
          formArray.removeAt(0)
        }
      } else {
        let index = formArray.controls.findIndex(x => x.value == value);
        if (index > -1) {
          formArray.removeAt(index);
        }
        if (formArray.value.indexOf(0) > -1) {
          if (this.filterLookUpData[type].length != formArray.value.length - 1) {
            let idx = formArray.controls.findIndex(x => x.value == 0);
            if (idx > -1) {
              formArray.removeAt(idx);
            }
          }
        }
      }
    }
  }

  get getSelectedEmployees() {
    return this.utilService.cleanArray(this.employeesList.map(employee => {
      if (employee.checked) {
        this.activateAction = true;
        console.log('checked');
        return employee.loyaltyMemberId;
      } else {
        console.log('unchecked');
        this.activateAction = false;
        return null;
      }
    }))
  }

  selectedValue(control, value) {
    this.filterForm.controls[control].setValue(value);
  }

  formStr(str) {
    return str.replace(/[^a-zA-Z ]/g, "");
  }

  selectEmployees(type) {
    if (type == 'all') {
      for (var i = 0; i < this.employeesList.length; i++) {
        this.employeesList[i].checked = this.allEmployeesSelected;
      }
    } else {
      this.allEmployeesSelected = this.employeesList.every(function (item: any) {
        return item.checked == true;
      })
    }
    this.selectedEmployees = this.getSelectedEmployees;
    console.log('this.selectedBenefits', this.selectedEmployees);
  }


  checkFilterOn() {
    let formGroup = this.filterForm.value;
    if (!formGroup.startDate && !formGroup.endDate && !formGroup.status && !formGroup.department && !formGroup.position && !formGroup.area && formGroup.hotelIds && formGroup.hotelIds.indexOf(0) > -1) {
      return false;
    } else {
      return true;
    }
  }

  checkGroupFilter() {
    if (!this.isFilterOn && !this.searchForm.get('searchTerm').value) {
      return false;
    } else {
      return true;
    }
  }

  pageChanged($event) {
    let page = $event - 1;
    this.getEmployeesList(page);
    this.allEmployeesSelected = false;
    this.selectEmployees('all');
    this.p = $event;
  }

  getEmployeesList(page?) {
    let headerColumns = Object.assign([], this.tableHeader);
    headerColumns.push(headerColumns.shift());
    let data = {
      filter: this.filterForm.value,
      isFilterOn: this.isFilterOn,
      pageNumber: page != null ? page : this.p,
      hotelChainId: JSON.parse(localStorage.getItem('loggedInUser')).hotelChainId,
      value: this.searchForm.get('searchTerm').value,
      sorting: headerColumns
    }
    console.log('====== option data =======', data);
    this.employeeService.getEmployeeList(data).subscribe(res => {
      if (res.error == 0) {
        this.isFiltered = this.checkGroupFilter();
        this.employeesList = res.responseObj.results;
        this.totalCount = res.responseObj.totalRecords;
      }
    }, err => {
      console.error('Error while fetching Employee List: ', err.message);
    })
  }

  clearDate() {
    if (this.filterForm.get('range').value) {
      this.filterForm.get('range').setValue(null);
      this.filterForm.get('startDate').setValue(null);
      this.filterForm.get('endDate').setValue(null);
    }
  }

  openStatusModal(id?, mode?) {
    this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
    let message = mode == 0 ? "Are you sure you want to deactivate this Employee(s)?" : "Are you sure you want to activate this Employee(s)?";
    let title = mode == 0 ? "Deactivate Employee" : "Activate Employee";
    let action1 = mode == 0 ? "Deactivate" : "Activate";
    let style = mode == 0 ? "inactive" : "active";
    let status = mode;
    this.statusModal.content.srcObject = {
      mode: "custom",
      type: 'member-edit',
      title: title,
      message: message,
      status,
      id: id,
      action1: action1,
      action2: 'Cancel',
      action: '',
      style: style
    }
  }

  initFilterForm() {
    let hotels = this.fb.array([]);
    this.filterForm = this.fb.group({
      status: [''],
      department: [''],
      position: [''],
      area: [''],
      range: [null],
      startDate: [null],
      endDate: [null],
      hotelIds: hotels
    });
    this.filterForm.controls['range'].valueChanges.debounceTime(200).subscribe(value => {
      if (!value || (value && !value.length)) {
        this.filterForm.get('startDate').setValue(null);
        this.filterForm.get('endDate').setValue(null);
      } else {
        this.filterForm.get('startDate').setValue(value[0] ? this.utilService.formatDate(value[0]) : null);
        this.filterForm.get('endDate').setValue(value[1] ? this.utilService.formatDate(value[1]) : null);
      }
    })
    this.filterForm.valueChanges.debounceTime(400).distinctUntilChanged().subscribe(value => {
      this.isFilterOn = this.checkFilterOn();
      this.pageChanged(1);
    })
  }

  initSearchForm() {
    this.searchForm = this.fb.group({
      searchTerm: ['']
    });
    this.searchForm.get('searchTerm').valueChanges.debounceTime(400).distinctUntilChanged()
      .subscribe(term => {
        this.pageChanged(1);
      })
  }

  ngOnInit() {
    this.initFilterForm();
    this.initSearchForm();
    this.getfilterLookUpData();
    this.getEmployeesList();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/employees/employee-list/employee-list.component.ts